import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import RoutesConstants from '../../../@commons/constants/routes.constants';

/**
 * Bottom-sheet « Que souhaitez-vous faire ? » (maquette 02).
 * Déclenché par le « + » de Mon Potager.
 */
@Component({
  selector: 'vw-garden-actions-toast',
  imports: [SharedModule, TranslatePipe],
  templateUrl: './garden-actions-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './garden-actions-toast.component.scss',
})
export class GardenActionsToastComponent extends BaseToastComponent {
  constructor(private router: Router) {
    super();
  }

  addBed(): void {
    this.onClose();
    this.router.navigate([RoutesConstants.GARDEN_BED_CREATE]);
  }

  addPlant(): void {
    this.onClose();
    this.router.navigate([RoutesConstants.GARDEN_ADDPLANT]);
  }

  viewHistory(): void {
    this.onClose();
    this.router.navigate([RoutesConstants.GARDEN_HISTORY]);
  }

  addZone(): void {
    // Ouvre le formulaire de zone (réutilisé) hébergé par « Mon Potager » via un signal d'URL.
    this.onClose();
    this.router.navigate([RoutesConstants.GARDEN_LIST], {
      queryParams: { addZone: 1 },
    });
  }
}
